import HowToPlayListItem from "app/ui/HowToPlayListItem";
import TypoWord from "app/ui/TypoWord";
import cn from "app/utils/classnames";

export default function getTedWordInstructions(): React.ReactNode {
  return (
    <ul className={cn("list-disc", "pl-4", "flex flex-col gap-2")}>
      <HowToPlayListItem key={0}>
        <TypoWord word="Spell" /> the word missing from the{" "}
        <TypoWord word="video" /> transcript.
      </HowToPlayListItem>
      <HowToPlayListItem key={1}>
        <TypoWord word="You'll" /> get three <TypoWord word="attempts" />.
      </HowToPlayListItem>
    </ul>
  );
}
